"use client";
import React from "react";
import { twMerge } from "tailwind-merge";
import { format } from "date-fns";
import CalendarIcon from "@/assets/icons/calendar.svg";

export interface Props {
  className?: string;
  value: number | string;
  displayTime?: boolean;
}

const DateComponent = ({ className, value, displayTime = false }: Props) => {
  const dateObj = new Date(value);
  const date = format(dateObj, "d MMMM, yyyy");

  const time = displayTime ? format(dateObj, "hh:mm aa") : null;

  return (
    <div
      className={twMerge(
        "text-body-1 flex justify-end items-center lg:justify-center gap-x-4",
        className,
      )}
    >
      <CalendarIcon className="w-6 fill-primary" />
      <div className="text-body-3">
        <div className="whitespace-nowrap w-[150px]">{date}</div>
        {displayTime && (
          <div className="text-secondary endemic:text-primary">{time}</div>
        )}
      </div>
    </div>
  );
};

export default DateComponent;
